import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Util from '../../../../../misc/util';
import { CardRequestCost } from '../../../../../queries/pxtraCard';

export const CostCell: FC<{ cost: CardRequestCost }> = ({ cost }) => {
  const { t } = useTranslation();

  return (
    <Box className="flex flex-col whitespace-nowrap">
      {cost.one_off_cents > 0 && (
        <Typography variant="body2" className="leading-4">
          {t('pxtraCard:costOneOff', { amount: Util.formatCurrency(cost.one_off_cents) })}
        </Typography>
      )}
      {cost.recurring_monthly_cents > 0 && (
        <Typography
          className="leading-4"
          variant={cost.one_off_cents > 0 ? 'caption' : 'body2'}
          color={cost.one_off_cents > 0 ? 'grey.600' : undefined}
        >
          {t('pxtraCard:costRecurring', {
            amount: Util.formatCurrency(cost.recurring_monthly_cents)
          })}
        </Typography>
      )}
    </Box>
  );
};
